import script from "./block-editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./block-editor.vue?vue&type=script&setup=true&lang=ts"

import "./block-editor.vue?vue&type=style&index=0&id=1d138f6e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d138f6e"]])

export default __exports__